import {
  ICONS_WEB,
  NAV_ITEM_GROUPS,
  PLATFORM_MODULES,
} from "@miplatform/constants";
import { accountingNavItems } from "./accounting/accountingNavItems";
import { dispatchNavItems } from "./dispatch/dispatchNavItems";
import { estimatingNavItems } from "./estimating/estimatingNavItems";
import { homesNavItems } from "./homes/homesNavItems";
import { schedulingNavItems } from "./scheduling/schedulingNavItems";

/**
 * These are the main nav items displayed in the persistent left nav drawer
 * The "group" attribute is used to place nav items into labeled sections
 */
export const navItems = (
  dispatchCalendarNavItems = [],
  schedulingCalendarNavItems = [],
  inspectionCalendarNavItems = []
) => [
  {
    name: PLATFORM_MODULES.MI_DISPATCH,
    icon: ICONS_WEB.HEADSET,
    path: "/dispatch",
    testId: "nav-item-mi-dispatch",
    items: dispatchNavItems.concat(dispatchCalendarNavItems),
    group: NAV_ITEM_GROUPS.MODULES,
  },
  {
    name: PLATFORM_MODULES.MI_SCHEDULING,
    icon: ICONS_WEB.CALENDAR_BLANK_OUTLINE,
    path: "/scheduling",
    testId: "nav-item-mi-scheduling",
    items: schedulingNavItems.concat(schedulingCalendarNavItems),
    group: NAV_ITEM_GROUPS.MODULES,
  },
  {
    name: PLATFORM_MODULES.MI_ACCOUNTING,
    icon: ICONS_WEB.CURRENCY,
    path: "/accounting",
    testId: "nav-item-mi-accounting",
    items: accountingNavItems,
    group: NAV_ITEM_GROUPS.MODULES,
  },
  {
    name: PLATFORM_MODULES.MI_INSPECTIONS,
    icon: ICONS_WEB.CLIPBOARD_SEARCH_OUTLINE,
    path: "/inspections",
    testId: "nav-item-inspections",
    items: inspectionCalendarNavItems,
    group: NAV_ITEM_GROUPS.MODULES,
  },
  {
    name: PLATFORM_MODULES.MI_ESTIMATING,
    icon: ICONS_WEB.FLOOR_PLAN,
    path: "/estimating",
    testId: "nav-item-mi-estimating",
    items: estimatingNavItems,
    group: NAV_ITEM_GROUPS.MODULES,
  },
  ...homesNavItems,
  {
    name: "Communities",
    icon: ICONS_WEB.HOME_CITY_OUTLINE,
    path: "/communities",
    testId: "nav-item-communities",
    group: NAV_ITEM_GROUPS.GENERAL,
  },
  {
    name: "MiConfig",
    icon: ICONS_WEB.COG,
    path: "/config",
    testId: "nav-item-settings",
    group: NAV_ITEM_GROUPS.SETTINGS,
  },
];
